module.exports = __webpack_public_path__ + "img/es.4b172fd6.png";